import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import ChevronDisabled from '../../../assets/icons/ChevronDownDisabled.svg';
import ChevronDownGray from '../../../assets/icons/ChevronDownGray.svg';

const ContentLayout = styled.div`
  border-radius: 12px;
  background-color: ${({ isDesktop }) => (isDesktop ? select('grayLight') : 'transparent')};
  padding: ${({ isDesktop }) => (!isDesktop ? 0 : 8)}px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContainerDropdown = styled.div`
  position: relative;
  width: ${({ width }) => width};
`;

const CollapsedDropdownTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
  > div {
    font-family: 'Hind';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }
`;

const TabSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  > img {
    height: 20px;
  }
  color: ${({ disabled }) => select(disabled ? 'midLightGray' : 'black')};
`;

const Separator = styled.div`
  height: 1px;
  width: 96%;
  background-color: ${select('middleGray')};
  margin: 11px 0px 0px 0px;
`;

const Chevron = styled.button`
  width: 23px;
  height: 23px;
  background-image: ${({ disabled }) => `url(${disabled ? ChevronDisabled : ChevronDownGray})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
  transform: ${({ active }) => `rotateX(${active ? '180deg' : '0deg'})`};
  transition: all 0.4s ease;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  margin-right: 6px;
`;

const OpenDropdownTabs = styled.div`
  position: absolute;
  top: 25px;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
  padding: 8px 0px 0px 0px;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGray')};
  background-color: ${select('white')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.4s ease;
  z-index: 3;
`;

const ListTabs = styled.div`
  height: 45px;
  padding-top: 10px;
  padding-left: 14px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  :hover {
    font-weight: 600;
    line-height: 130%;
    background-color: ${select('lightGray')};
  }
  :last-of-type {
    border-radius: 0 0 8px 8px;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${select('midLightGray')};
      :hover {
        font-weight: 400;
        line-height: 22px;
        background-color: transparent;
      }
    `}
`;

export {
  ContentLayout,
  ContainerDropdown,
  CollapsedDropdownTabs,
  TabSection,
  Chevron,
  OpenDropdownTabs,
  ListTabs,
  Separator
};
